<template>
  <div
    class="CheckSeat bg-white"
    v-if="checkSeatShow"
  >
    <h3 class="font16">
      选择座位
    </h3>

    <div class="seat-list van-hairline--bottom ">
      <van-checkbox-group
        v-model="seat.seatCheck"
        v-for="(seat, i) in SeatList"
        :key="i"
        :max="seat.max"
        :disabled="seat.max === 0"
      >
        <div :style="{ marginTop: i > 0 ? '-10px': '' }">
          <van-row
            type="flex"
            justify="space-around"
          >
            <van-col>
              <div class="street">
                窗
              </div>
            </van-col>
            <van-col
              v-for="(item, index) in seat.seatList"
              :key="index"
            >
              <van-checkbox
                class="seat-checkbox"
                :name="`${i + 1}${item}`"
                :disabled="!item"
                :style="{ 'margin': { 4: '0 4px', 5: '0 4px' }[seat.seatList.length] }"
                @click="clickEvent(item, i, seat)"
              >
                <div
                  class="relative"
                  v-if="item"
                  slot="icon"
                  slot-scope="props"
                >
                  <ld-icon
                    :class="props.checked ? 'main-color' : 'light-gray'"
                    size="32"
                    :type="`icon${item}_seat`"
                  />
                </div>
                <div
                  v-else
                  class="street"
                >
                  过道
                </div>
              </van-checkbox>
            </van-col>
            <van-col>
              <div class="street">
                窗
              </div>
            </van-col>
          </van-row>
        </div>
      </van-checkbox-group>
    </div>

    <p class="font10 gray">
      {{ $t('I071', '若剩余席位无法满足您的需求，系统将自动为您分配席位') }}
    </p>
  </div>
</template>

<script>
/**
 * 商务舱('9')坐席号分为AC、F，其中A靠窗、C靠走廊、F靠窗及走廊;
 * 一等座('M')坐席号为AC、DF，其中A、F靠窗,C、D靠走廊;
 * 二等座('O')坐席号为ABC、DF，其中A、F靠窗,C、D靠走廊，B在AC中间。
 */
import { CheckboxGroup, Checkbox } from 'vant'

const ACF_SEATTYPE = ['9']
const ACDF_SEATTYPE = ['M']
const ABCDF_SEATTYPE = ['O']

const getSeatList = (seatType) => {
  if (ACF_SEATTYPE.includes(seatType)) {
    return ['A', 'C', null, 'F']
  } else if (ACDF_SEATTYPE.includes(seatType)) {
    return ['A', 'C', null, 'D', 'F']
  } else if (ABCDF_SEATTYPE.includes(seatType)) {
    return ['A', 'B', 'C', null, 'D', 'F']
  }
}

export default {
  components: {
    [CheckboxGroup.name]: CheckboxGroup,
    [Checkbox.name]: Checkbox
  },
  props: {
    value: {
      type: String,
      default: ''
    },
    max: {
      type: Number,
      default: 1
    },
    trainType: {
      type: String,
      default: ''
    },
    seatType: {
      type: String,
      default: 'O' // 默认 二等座（O）
    },
  },
  data() {
    return {
      SeatList: [{
        seatCheck: [],
        max: 1,
        seatList: getSeatList(this.seatType)
      }],  // null 用于 渲染 “过道” 的div
      clickNum: 0
    }
  },
  computed: {
    // 判断 火车票 是否能选座	
    checkSeatShow () {
      return !!getSeatList(this.seatType)
    }
  },
  methods: {
    clickEvent (seatNum, i, seat) {
      if (!seatNum) return
      this.clickNum += 1
      seatNum = `${i + 1}${seatNum}`

      let checkedNum = 0, // 当前已选座席数
        one_checklen = this.SeatList[0].seatCheck.length,
        two_checklen = this.SeatList[1] ? this.SeatList[1].seatCheck.length : 0
      
      checkedNum += one_checklen
      if (this.max > 1) {
        checkedNum += two_checklen
      }

      if (this.clickNum > 2 && checkedNum === this.max) {
        if (two_checklen > 0) {
          this.SeatList[1].seatCheck.splice(two_checklen - 1, 1)
          seat.seatCheck.push(seatNum)
        } else if (one_checklen > 0) {
          this.SeatList[0].seatCheck.splice(one_checklen - 1, 1)
          seat.seatCheck.push(seatNum)
        }
      }

    }
  },
  watch: {
    SeatList: {
      handler (val) {
        let res = ''
        res += val[0].seatCheck.join('')
        if (this.max > 1) {
          res += val[1].seatCheck.join('')
        }

        this.$emit('update:value', res)

        if (!res) this.clickNum = -1
          
        if (this.max > 1) {
          val[0].max = this.max - val[1].seatCheck.length
          val[1].max = this.max - val[0].seatCheck.length
        } else {
          val[0].max = this.max
        }

      },
      deep: true
    },
    max: {
      handler (val) {
        if (val >= 2 && this.SeatList.length === 1) {
          this.SeatList.push({
            seatCheck: [],
            max: 1,
            seatList: getSeatList(this.seatType)
          })
        } else if (val === 1 && this.SeatList.length === 2) {
          this.SeatList.splice(1, 1)
        } else if (val === 1 && this.SeatList.length === 1) {
          this.SeatList[0].max = 1
        } else if (val === 0) {
          this.SeatList[0].seatCheck = []
        }

        // 减少出行人的时候 把座位去掉
        let checkedNum = 0, // 当前已选座席数
          one_checklen = this.SeatList[0].seatCheck.length,
          two_checklen = this.SeatList[1] ? this.SeatList[1].seatCheck.length : 0
        
        checkedNum += one_checklen
        if (this.max > 1) {
          checkedNum += two_checklen
        }

        if (checkedNum > this.max) {
          if (two_checklen > 0) {
            this.SeatList[1].seatCheck.splice(two_checklen - 1, 1)
          } else if (one_checklen > 0) {
            this.SeatList[0].seatCheck.splice(one_checklen - 1, 1)
          }
        }

      },
      immediate: true
    }
  }
}
</script>

<style lang="less">
.CheckSeat {
  padding: 10px 16px 0;

  h3 {
    margin: 0;
  }

  p {
    margin: 0;
    line-height: 30px;
  }

  .seat-list {
    padding: 10px 0;
  }

  .street {
    display: inline-block;
    border-left: 1px solid @color-background-lightGray;
    border-right: 1px solid @color-background-lightGray;
    width: 24px;
    margin: 0 3px;
    padding: 15px 0;
    line-height: initial;
    text-align: center;
    font-size: @font-size-12;
    color: @color-text-gray;
    background-image: linear-gradient(0deg, 
      #ffffff 0%, 
      #fbfbfa 15%, 
      #f6f6f5 50%, 
      #fbfbfa 85%, 
      #ffffff 100%), 
    linear-gradient(
      #f9f9f6, 
      #f9f9f6);
    background-blend-mode: normal, 
      normal;
  }

  .seat-checkbox {
    display: inline-block;
    vertical-align: middle;
    
    .street {
      vertical-align: top;
      padding: 7px 0;
    }

    .van-checkbox__icon {
      height: auto;
      font-size: 44px;
    }

    img {
      width: 44px;
    }
  }
}
</style>
